'use client'

import { AUTH_TOKEN_COOKIE, NEW_USER_COOKIE } from '@/constants'
import { isOnServer } from '@/utils'

import { deleteCookieClient, setCookieClient } from '../../../utils/client'

export const ROLE_COOKIE = 'role'

export const setAuthTokenCookie = (token: string | null, role?: string) => {
	if (token) {
		setAuthCookies(token, role)
	} else if (!isOnServer) {
		deleteCookieClient(AUTH_TOKEN_COOKIE)
		deleteCookieClient(ROLE_COOKIE)
	}
}

export const setAuthCookies = (token: string, role?: string) => {
	setCookieClient(AUTH_TOKEN_COOKIE, token, { days: 7 })
	if (role) {
		setCookieClient(ROLE_COOKIE, role, { days: 7 })
	}
}

export const setNewUserCookie = (
	value: string,
	options: {
		days?: number
		path?: string
		secure?: boolean
		sameSite?: 'Strict' | 'Lax' | 'None'
	} = { days: 7 },
) => {
	setCookieClient(NEW_USER_COOKIE, value, options)
}
